<template>
  <v-container
    grid-list-md
    fluid
    class="grey lighten-4"
    v-if="operations && operations.length > 0"
  >
    <v-layout class="row wrap align-center justify-end row fill-height">
      <v-flex xs12 sm12 md12>
        <v-layout class="row wrap align-center justify-end row fill-height">
          <v-flex xs12 sm12 md6>
            <v-card class="white black--text" flat>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout
                  class="row wrap align-center justify-end row fill-height"
                >
                  <v-flex xs6 sm6 md5 class="pb-10">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      dark
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="startDateFormatted"
                          label="Data Inicial"
                          hint="DD/MM/AAAA"
                          persistent-hint
                          prepend-icon="event"
                          @blur="startDate = parseDate(startDateFormatted)"
                          v-on="on"
                          :rules="[
                            (v) => !!v || 'Informe a Data de inicio',
                            (v) => !!validDate(startDate) || 'Data inválida!',
                            (v) =>
                              !!is_between(startDate, endDate) ||
                              'Intervalo não pode ser maior que 60 dias!',
                          ]"
                          mask="##/##/####"
                          return-masked-value
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="startDate"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                    <!-- <p>Date in ISO format: <strong>{{ startDate }}</strong></p> -->
                  </v-flex>
                  <v-flex xs6 sm6 md5>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      mask="##/##/####"
                      dark
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="endDateFormatted"
                          label="Data Final"
                          hint="DD/MM/AAAA"
                          persistent-hint
                          prepend-icon="event"
                          @blur="endDate = parseDate(endDateFormatted)"
                          v-on="on"
                          :rules="[
                            (v) => !!v || 'Informe a Data de inicio',
                            (v) => !!validDate(endDate) || 'Data inválida!',
                            (v) =>
                              !!is_earlier(startDate, endDate) ||
                              'Data final menor que a data inicial!',
                            (v) =>
                              !!is_between(startDate, endDate) ||
                              'Intervalo não pode ser maior que 60 dias!',
                          ]"
                          required
                          mask="##/##/####"
                          return-masked-value
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endDate"
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                    <!-- <p>Date in ISO format: <strong>{{ endDate }}</strong></p> -->
                  </v-flex>
                  <v-flex xs12 sm12 md2>
                    <v-btn
                      fab
                      dark
                      small
                      color="primary"
                      @click.prevent="_search"
                      :disabled="!valid || loadingOperations"
                    >
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-flex>
          <v-flex xs12 sm12 md6> </v-flex>
          <v-flex xs12 sm12 md4>
            <!-- <v-layout class="row wrap align-center justify-end row fill-height">
							<v-flex xs12 sm12 md6> -->
            <v-card class="white black--text">
              <v-card-text>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div class="text-xs-center">
                      <span class="grey--text text--darken-3"
                        >Total de entradas</span
                      >
                      <v-icon right small color="green" v-on="on"
                        >help_outline</v-icon
                      >
                      <div class="headline pt-3 pb-4">
                        <span class="green--text">+</span> R$
                        {{ inputTotal | formatCurrency }}
                      </div>
                    </div>
                  </template>
                  <span>Todos os lançamentos de vendas brutas.</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
            <!-- </v-flex> -->
          </v-flex>
          <v-flex xs12 sm12 md4>
            <!-- <v-flex xs12 sm12 md6> -->
            <v-card class="white black--text">
              <v-card-text>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div class="text-xs-center">
                      <span class="grey--text text--darken-3"
                        >Total de saídas</span
                      >
                      <v-icon right small color="red" v-on="on"
                        >help_outline</v-icon
                      >
                      <div class="headline pt-3 pb-4">
                        <span class="red--text">-</span> R$
                        {{ outputTotal | formatCurrency }}
                      </div>
                    </div>
                  </template>
                  <span
                    >Todos os lançamentos de transferências, chargebacks e
                    estornos.</span
                  >
                </v-tooltip>
              </v-card-text>
            </v-card>
            <!-- </v-flex>
						</v-layout> -->
          </v-flex>
          <v-flex xs12 sm12 md4>
            <!-- <v-flex xs12 sm12 md6> -->
            <v-card class="white black--text">
              <v-card-text>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div class="text-xs-center">
                      <span class="blue--text text--darken-3"
                        >Total líquido</span
                      >
                      <v-icon right small color="blue" v-on="on"
                        >help_outline</v-icon
                      >
                      <div class="headline pt-3 pb-4">
                        <span class="blue--text">{{
                          totalLiquido > 0 ? "+" : "-"
                        }}</span>
                        R$
                        {{
                          totalLiquido > 0
                            ? totalLiquido
                            : (totalLiquido * -1) | formatCurrency
                        }}
                      </div>
                    </div>
                  </template>
                  <span
                    >Todos os lançamentos de vendas descontando as taxas,
                    chargebacks e estornos.</span
                  >
                </v-tooltip>
              </v-card-text>
            </v-card>
            <!-- </v-flex>
						</v-layout> -->
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <v-card>
          <v-card-title>
            <div class="">
              Extrato: {{ this.startDateFormatted }} -
              {{ this.endDateFormatted }}
            </div>
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green"
                  v-on="on"
                  :loading="loadingExport"
                  :disable="loadingExport"
                  small
                >
                  Exportar
                  <v-icon right dark>save_alt</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click.prevent="_export('csv')">
                  <v-list-tile-title>csv</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click.prevent="_export('xlsx')">
                  <v-list-tile-title>excel</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="operations" :search="search">
            <template v-slot:items="props">
              <td>{{ props.item.date_created | formatDateOperation }}</td>
              <td class="">{{ props.item.id }}</td>
              <td class="">
                {{ props.item.movement_object.transaction_id || "----" }}
              </td>
              <td class="">
                {{
                  props.item.movement_object.payment_method ||
                  props.item.type | formatDescricao
                }}
              </td>
              <td class="text-xs-right">
                R$
                {{
                  props.item.amount >= 0
                    ? props.item.amount / 100
                    : 0 | formatCurrency
                }}
              </td>
              <td class="text-xs-right">
                <div v-if="props.item.amount >= 0">
                  R$
                  {{
                    ((props.item.fee * -1) / 100).toFixed(2).replace(".", ",")
                  }}
                </div>
                <div v-else>
                  <div>
                    (TED) R$
                    {{
                      ((props.item.fee * -1) / 100).toFixed(2).replace(".", ",")
                    }}
                  </div>
                  <div>
                    R$
                    {{ (props.item.amount / 100).toFixed(2).replace(".", ",") }}
                  </div>
                </div>
              </td>
              <td
                :class="
                  props.item.amount >= 0
                    ? 'text-xs-right font-weight-bold  green--text'
                    : 'text-xs-right font-weight-bold deep-purple--text darken-4'
                "
              >
                R$
                {{
                  ((props.item.amount - props.item.fee) / 100) | formatCurrency
                }}
              </td>
            </template>
            <template v-slot:pageText="props">
              Linhas {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua busca para "{{ search }}" não encontrou resultados.
              </v-alert>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {
  mapActions, //, mapGetters
  mapState,
  mapMutations,
} from "vuex";
import moment from "moment";
import { toDate } from "../../utils/dates";
export default {
  data: (vm) => ({
    operations: [],
    startDate: new Date().toISOString().substr(0, 10),
    startDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    endDate: new Date().toISOString().substr(0, 10),
    endDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu2: false,
    headers: [
      {
        text: "DATA",
        align: "left",
        sortable: true,
        value: "date_created",
      },
      { text: "ID DA OPERAÇÃO", value: "id" },
      { text: "ID DA TRANSAÇÃO", value: "transaction_id" },
      { text: "DESCRIÇÃO", value: "payment_method" },
      { text: "ENTRADAS", value: "amount" },
      { text: "SAÍDAS", value: "fee" },
      { text: "TOTAL", value: "total" },
    ],
    search: "",
    totalItems: 15,
    loadingExport: false,
    valid: false,
    loadingOperations: false,
  }),
  computed: {
    ...mapState("extrato", ["balanceOperations", "partner", "bankAccount"]),
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    inputTotal() {
      let sum = this.operations.reduce((sum, acc) => {
        if (acc.movement_object.type === "credit") {
          return sum + acc.amount / 100;
        } else {
          return sum;
        }
      }, 0);
      // console.log('inputTotal: ', sum)
      return sum;
    },
    outputTotal() {
      let sum = this.operations.reduce((sum, acc) => {
        if (acc.movement_object.type !== "credit") {
          return sum + acc.amount / 100;
        } else {
          return sum;
        }
      }, 0);
      if (Number(sum)) sum = sum * -1;
      return sum;
    },
    totalLiquido() {
      return this.inputTotal - this.outputTotal;
    },
  },
  mounted() {
    if (this.balanceOperations) {
      this.operations = this.balanceOperations.reverse();
    }
    let start_date = new Date();
    start_date = start_date.setDate(start_date.getDate() - 7);
    this.startDate = new Date(start_date).toISOString().substring(0, 10);
  },
  watch: {
    balanceOperations(val) {
      this.operations = val;
    },
    startDate(val) {
      if (this.validDate(val)) this.startDateFormatted = this.formatDate(val);
    },
    endDate(val) {
      if (this.validDate(val)) this.endDateFormatted = this.formatDate(val);
    },
  },
  methods: {
    ...mapMutations("extrato", ["setFilter"]),
    ...mapActions("extrato", ["getBalanceItems", "exportBalanceItems"]),
    _search() {
      // this.resetFilter()
      this.loadingOperations = true;
      let params = {};
      if (this.bankAccount) {
        params.recipient_id = this.bankAccount.id;
      }
      if (this.startDate) {
        params.startDate = new Date(this.startDate + "T00:00:00").getTime();
      }
      if (this.endDate) {
        params.endDate = new Date(this.endDate + "T23:59:59").getTime();
      }
      this.getBalanceItems(params)
        .then(() => (this.loadingOperations = false))
        .catch((err) => {
          console.error(err);
          this.loadingOperations = false;
        });
      params.partner = this.partner;
      params.bankAccount = this.bankAccount;
      this.setFilter(params);
    },
    _export(format) {
      // this.resetFilter()
      this.loadingExport = true;
      let params = {};
      if (this.bankAccount) {
        params.recipient_id = this.bankAccount.id;
      }
      if (this.startDate) {
        params.startDate = new Date(this.startDate + "T00:00:00").getTime();
      }
      if (this.endDate) {
        params.endDate = new Date(this.endDate + "T23:59:59").getTime();
      }
      params.format = format;
      this.exportBalanceItems(params)
        .then((file) => {
          if (!file)
            alert("Ocorreu um erro na exportação, contate nosso suporte.");
          let type =
            format === "xlsx"
              ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              : "text/csv;charset=utf-8;";
          // let type = format === 'xlsx'?'application/vnd.ms-excel':'text/csv;charset=utf-8;'
          // console.log('type: ', type)
          const url = URL.createObjectURL(
            new Blob([file], {
              type: type,
            }),
          );
          let filename =
            this.bankAccount.id + "-" + new Date().toISOString() + "." + format;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loadingExport = false;
        })
        .catch((err) => {
          console.error("export Error: " + err);
          this.loadingExport = false;
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    validDate(val) {
      return toDate(val) instanceof Date;
    },
    is_earlier(dtStart, dtEnd) {
      if (!(toDate(dtStart) instanceof Date)) return false;
      if (!(toDate(dtEnd) instanceof Date)) return false;
      if (new Date(dtEnd) < new Date(dtStart)) return false;
      else return true;
    },
    is_between(dtStart, dtEnd) {
      if (!(toDate(dtStart) instanceof Date)) return false;
      if (!(toDate(dtEnd) instanceof Date)) return false;

      if (new Date(dtEnd) - new Date(dtStart) > 5270400000) return false;
      else return true;
    },
  },
  filters: {
    formatDateOperation(value) {
      if (!value) return "-";
      return moment(value).format("DD/MM/YYYY");
    },
    formatDescricao(value) {
      if (!value) return "-";
      if (value === "transfer") return "Saque";
      else if (value === "credit_card") return "Cartão de crédito";
      else if (value === "boleto") return "Boleto";
      else "-";
    },
  },
};
</script>
